<template>
  <div
    :id="config.property_data.anchor_name"
    class="tms-anchor"
    :class="isEditorStatus ? '' : 'height0'"
  >
    <span>我是锚点，点击设置，最终页面上不会呈现我</span>
  </div>
</template>

<script>
export default {
  name: "tms-anchor",
  props: ["config", "isEditorStatus"],
  created() {
    this.query_selector = this.$route.query.query_selector;
    if (this.query_selector) {
      setTimeout(() => {
        this.goToAnchor(`#${this.query_selector}`);
      }, 200);
    }
  },
  methods: {
    goToAnchor(name) {
      const returnEle = document.querySelector(name); // 将要跳转区域的锚点id
      if (returnEle) {
        returnEle.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
    },
  },
};
</script>

<style  lang="scss" scoped>
@import "./index.scss";
</style>